<template>
  <header>
      <div class="app-bar">
          <a class="logo" v-scroll-to="'#app'"><Logo /></a>
          <a class="ham" @click="Ham()">
              <div class="bar" />
              <div class="bar" />
          </a>
      </div>
      <nav id="sidebar" v-show="Open">
          <ul>
              <li>
                  <a v-scroll-to="'#app'" @click="Closenav()">
                      <menuTop />
                  </a>
              </li>
              <li>
                  <a v-scroll-to="'#works'" @click="Closenav()">
                      <menuWorks />
                  </a>
              </li>
              <li>
                  <a v-scroll-to="'#about'" @click="Closenav()">
                      <menuAbout />
                  </a>
              </li>
              <li>
                  <a href="https://www.instagram.com/quadpro2020/" target="_blank">
                    <IconInsta />
                  </a>
              </li>
          </ul>
      </nav>
  </header>
</template>

<script>

import Logo from '@/assets/icon/logo.svg?inline';
import menuTop from '@/assets/icon/h2/menu_top.svg?inline';
import menuWorks from '@/assets/icon/h2/menu_works.svg?inline';
import menuAbout from '@/assets/icon/h2/menu_about.svg?inline';
import IconInsta from '@/assets/icon/icon_insta.svg?inline';

export default {
  name: 'Header',
  components: {
      Logo,
      menuTop,
      menuWorks,
      menuAbout,
      IconInsta
  },
  data(){
      return{
          Open: false
      }
  },
  methods:{
      Opennav: function(){
          this.Open = true;
          document.getElementsByTagName('html')[0].classList.add("isfixed")
          setTimeout(() => {
              document.getElementById('sidebar').classList.add("active");
          }, 200);
      },
      Closenav: function(){
          document.getElementById('sidebar').classList.remove("active");
          document.getElementsByTagName('html')[0].classList.remove("isfixed");
          setTimeout(() => {
            this.Open = false;
          }, 600);
      },
      Ham:function(){
          if( !this.Open ){
              this.Opennav();
          }
          else{
              this.Closenav();
          }
          console.log(this.Open);
      }
  }
}
</script>

<style lang="scss">

$transition: 0.4s;

header{
    width: 100%;
    margin: 0 auto;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    .app-bar{
        z-index: 10000;
        a{
            &::after{
                position: absolute;
                width: 100%;
                text-align: center;
                bottom: -1.2em;
                left: 0;
                margin-top: 6px;
                opacity: 0;
                transition: $transition;
                font-size: 10px;
                letter-spacing: 0.182em;
            }
        }
        a.logo{
            width: 54px;
            height: 42px; 
            position: absolute;
            left: 34px;
            top: 24px;
            @media #{$maxM} {
                left: 24px;
            }
            &::after{
                content: 'TOP';
            }
            &:hover{
                &::after{
                    opacity: 1;
                    transition: $transition;
                }
            }
        }
        a.ham{
            width: 32px;
            height: 42px;
            padding: 0 11px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            position: absolute;
            right: 34px;
            top: 24px;
            @media #{$maxM} {
                right: 24px;
                padding-right: 0;
            }
            &::after{
                //content: 'MENU';
            }
                .bar{
                    height: 1px;
                    background: $black;
                    margin-top: 12px;
                    transition: $transition;
                    &:first-child{
                        margin-top: 0;
                        width: 32px;
                    }
                    &:last-child{
                        width: 16px;
                    }
                }
                &:hover{
                    .bar:first-child{
                        width: 36px;
                    }
                    .bar:last-child{
                        width: 32px;
                    }
                    &::after{
                        opacity: 1;
                        transition: $transition;
                    }
                }
        }
    }

    #sidebar{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        width: 100vw;
        height: 100vh;
        background: $white;
        opacity: 0;
        transition: 0.6s;
        z-index: 1000;
            &.active{
                opacity: 1;
                transition: 0.6s;
            }
            ul{
                display: flex;
                justify-content: center;
                align-items: center;
                flex-flow: column;
                    li{
                        display: block;
                        font-weight: 600;
                        margin-bottom: 4rem;
                        height: 1.84rem;
                        letter-spacing: 0.05em;
                        &:last-child{
                            margin-bottom: 0;
                        }
                        a{
                            width: auto;
                            height: 100%;
                            margin: 0 auto;
                            display: block;
                            text-align: center;
                            padding: 6px 0;
                            position: relative;
                            transition: 0.4s;
                                svg{
                                    height: 100%;
                                    width: auto;
                                    margin: 0 auto;
                                    overflow: visible;
                                        path{
                                            transition: 0.4s;
                                        }
                                }
                                &::after{
                                    content: '';
                                    width: 0%;
                                    height: 2px;
                                    position: absolute;
                                    background: $black;
                                    left: 50%;
                                    bottom: -6px;
                                    transform: translateX(-50%);
                                    transition: 0.4s;
                                }
                            &:hover{
                                letter-spacing: 0.14em;
                                svg{
                                    $wide: 0.2rem;
                                    path.l2{
                                        transform: translateX( -$wide*2 );
                                    }
                                    path.l1{
                                        transform: translateX( -$wide );
                                    }
                                    path.center{
                                        transform: translateX(0);
                                    }
                                    path.r1{
                                        transform: translateX( $wide );
                                    }
                                    path.r2{
                                        transform: translateX( $wide*2 );
                                    }
                                }
                                &::after{
                                    width: 100%;
                                }
                            }
                        }
                    }
            }
    }
}

</style>
